export const BUSINESS_SEARCH_REQUEST = 'BUSINESS_SEARCH_REQUEST'
export const BUSINESS_SEARCH_SUCCESS = 'BUSINESS_SEARCH_SUCCESS'
export const BUSINESS_SEARCH_FAILED = 'BUSINESS_SEARCH_FAILED'
